// RESPONSIVE VIDEO!
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// PRODUCT PICKER
// VIDEO POP-UP
// LOTTERY FORM

//
// =RESPONSIVE VIDEO!
// --------------------------------------------------

const vid = document.getElementById("msdw-video-responsive");

function loadVideo() {
  var sm = window.matchMedia("(min-width: 0px) and (max-width: 599px)"), // Standard def (mp4, 640x360)
    md = window.matchMedia("(min-width: 600px) and (max-width: 899px)"), // Standard def (mp4, 960x540)
    lg = window.matchMedia("(min-width: 900px) and (max-width: 1199px)"), // High def (mp4, 1280x720)
    xl = window.matchMedia("(min-width: 1200px) and (max-width: 99999px)"); // High def 1080 (mp4, 1920x1080)

  sm.addListener($.proxy(changeVideoSize, this, "sm"));
  md.addListener($.proxy(changeVideoSize, this, "md"));
  lg.addListener($.proxy(changeVideoSize, this, "lg"));
  xl.addListener($.proxy(changeVideoSize, this, "xl"));

  if (sm.matches) {
    changeVideoSize("sm");
  } else if (md.matches) {
    changeVideoSize("md");
  } else if (lg.matches) {
    changeVideoSize("lg");
  } else if (xl.matches) {
    changeVideoSize("xl");
  }
}

function changeVideoSize(size) {
  const videoSource = $("#msdw-video-responsive source");
  videoSource.attr("src", videoSource.attr("data-video-" + size));
  vid.autoplay = true;
  vid.load();
  // console.log(videoSource.attr("src"));
}

if (document.contains(vid)) {
  document.addEventListener("DOMContentLoaded", loadVideo);
  window.onresize = loadVideo;
  vid.onloadeddata = () => vid.classList.add("msdw-video-loaded");
}

//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

$(".msdw-page-scroll").click(function () {
  if (
    location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") &&
    location.hostname == this.hostname
  ) {
    var target = $(this.hash);
    target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
    if (target.length) {
      var offsetValue = 0;
      if (window.innerWidth <= 767) {
        offsetValue;
        // console.log(offsetValue);
      } else {
        offsetValue = 59;
        // console.log(offsetValue);
      }

      $("html,body").animate(
        {
          scrollTop: target.offset().top - offsetValue,
        },
        900
      );
      return false;
    }
  }
});

//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

const scroll = window.requestAnimationFrame;

function showOnScroll() {
  const elems = document.querySelectorAll(".msdw-animate");

  elems.forEach((el) => {
    const elPosition = el.getBoundingClientRect().top;
    const elScreen = window.innerHeight / 0.9;

    if (elPosition < elScreen) {
      el.classList.add("msdw-animated");
    }
  });

  scroll(showOnScroll);
}

showOnScroll();

//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

const productSlider = new Swiper("#productSlider", {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  navigation: {
    nextEl: ".msdw-swiper-button-next",
    prevEl: ".msdw-swiper-button-prev",
  },
  breakpoints: {
    600: {
      slidesPerView: 3,
      spaceBetween: 15,
    },
    900: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});

const teamSlider = new Swiper("#teamSlider", {
  slidesPerView: 1.2,
  spaceBetween: 10,
  freeMode: true,
  grabCursor: true,
  breakpoints: {
    600: {
      slidesPerView: 1.72,
      spaceBetween: 15,
    },
    900: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    // 1920: {
    //   slidesPerView: 3.17,
    //   spaceBetween: 20,
    // },
  },
});

const daySlider = new Swiper("#daySlider", {
  slidesPerView: 1.21,
  spaceBetween: 10,
  freeMode: true,
  grabCursor: true,
  breakpoints: {
    600: {
      slidesPerView: 1.65,
      spaceBetween: 15,
    },
    900: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    // 1920: {
    //   slidesPerView: 3.17,
    //   spaceBetween: 20,
    // },
  },
});

//
// =PRODUCT PICKER
// --------------------------------------------------

const productPickers = document.querySelectorAll(".msdw-product-detail-picker");

productPickers.forEach((productPicker) => {
  const productIdNumber = productPicker.dataset.productId;
  productPicker.addEventListener("click", (e) => {
    e.preventDefault();
    window.jwsdwMediator.publish("openPicker", "productDetailPicker", {
      productId: productIdNumber,
    });
    console.log(e);
    console.log(`${productIdNumber} clicked`);
  });
});

//
// =VIDEO POP-UP
// --------------------------------------------------

const playVideoBtns = document.querySelectorAll(".msdw-play-video");
const msdwPopupVideoWrapper = document.querySelector(
  ".msdw-popup-video-wrapper"
);
const msdwPopupVideoBackDrop = document.querySelector(
  ".msdw-popup-video-backdrop"
);
const msdwPopupVideo = document.getElementById("msdwPopupVideo");

if (document.contains(msdwPopupVideoWrapper)) {
  // OPEN
  playVideoBtns.forEach((playVideoBtn) => {
    playVideoBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const videoUrl = playVideoBtn.href;
      msdwPopupVideo.setAttribute("src", videoUrl);
      msdwPopupVideoWrapper.classList.add("msdw-active");
      document.body.classList.add("jws-overflowHidden");
      msdwPopupVideo.muted = false;
      msdwPopupVideo.play();
    });
  });

  // CLOSE
  const closePopUpVideo = () => {
    document.body.classList.remove("jws-overflowHidden");
    msdwPopupVideo.muted = true;
    msdwPopupVideo.pause();
    msdwPopupVideo.currentTime = 0;

    msdwPopupVideoWrapper.classList.remove("msdw-active");
  };

  msdwPopupVideoBackDrop.addEventListener("click", () => {
    closePopUpVideo();
  });

  window.onkeydown = (e) => {
    if (e.keyCode == 27) closePopUpVideo();
  };
}

//
// =PLACE SLOT MODULE INSIDE THE LP
// --------------------------------------------------

const sliderSlot = document.getElementById('msdwSlidetSlot');
const catLandingMiddle = document.getElementById('cat-landing-middle');
catLandingMiddle && sliderSlot.appendChild(catLandingMiddle);

//
// =LOTTERY FORM
//  scroll to success message after form is sent
// --------------------------------------------------

// $(document).ready(function () {
//   $(".msdw-section-form").css("visibility", "visible");
// });

// $("#jwsdw-lottery-salutation").blur();

// var $div = $("#jwsdw-lotteryForm");
// var observer = new MutationObserver(function (mutations) {
//   mutations.forEach(function (mutation) {
//     if (mutation.attributeName === "class") {
//       var attributeValue = $(mutation.target).prop(mutation.attributeName);
//       // console.log("Class attribute changed to:", attributeValue);

//       $("html, body").animate(
//         {
//           scrollTop: $("#anchorToForm").offset().top - 70,
//         },
//         500
//       );
//     }
//   });
// });

// if ($($div).length) {
//   observer.observe($div[0], {
//     attributes: true,
//   });

//   // var fixOptionText = document.querySelector('option[value="UK"]');
//   // fixOptionText.innerHTML = "UK";
// }

// // COUNTRY PRE-SELECT
// const pageLocale = window.jwsdwSettings.locale;

// function changeCountryCode(c) {
//   document.getElementById("countryCode").value = c;
// }

// pageLocale === "de-IT" && changeCountryCode("IT");
// pageLocale === "en-IT" && changeCountryCode("IT");
// pageLocale === "en-LU" && changeCountryCode("LU");
// pageLocale === "fr-CH" && changeCountryCode("CH");
// pageLocale === "fr-FR" && changeCountryCode("DE");
// pageLocale === "fr-BE" && changeCountryCode("BE");
// pageLocale === "nl-BE" && changeCountryCode("BE");
